import React, { useState, useEffect } from "react";
import "../Navbar/Navbar.css";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const callAdmin = () => {
    window.location.href = "tel:+1234567890"; // Calls on mobile
  };
  return (
    <nav className="navbar">
      {/* Mobile Hamburger Menu */}
      {isMobile && (
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
          <div className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></div>
        </div>
      )}

      {/* Mobile Side Menu */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-content">
          <Link to="/" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/aboutus" onClick={closeMenu}>
            About
          </Link>
          <Link to="/services" onClick={closeMenu}>
            Services
          </Link>
          <Link to="/contactus" onClick={closeMenu}>
            Contact
          </Link>
          <button className="navbutton" onClick={callAdmin}>
            91000000000
          </button>
        </div>
      </div>

      {/* Desktop Version (unchanged) */}
      <div className="nav-links left">
        <Link to="/">Home</Link>
        <Link to="/aboutus">About</Link>
        <Link to="/services">Services</Link>
      </div>

      <div className="nav-logo">
        <Link to="/">
          <img src="logo.webp" alt="Logo" />
        </Link>
      </div>

      <div className="nav-links right">
        <Link to="/contactus">Contact</Link>
        <button className="navbutton">91000000000</button>
      </div>
    </nav>
  );
};

export default Navbar;
